import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractForgotPasswordComponent, mapStateToProps } from './abstract'
import { Input, Button, Checkbox } from '~/components/form'
import { LoginAnimation } from '~/components/animation'
import * as route from '~/helper/constant/route'
import { Loading } from '~/components/loader'
import { withTranslation } from 'react-i18next'

class ForgotPasswordComponent extends AbstractForgotPasswordComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }

    render() {
        const { t } = this.props
        return (
            <div className="clearfix login-page">
                <LoginAnimation />
                <Loading status={this.state.loading} text="Loading" />
                <div className="login-form">
                    <div className="login-main">
                        <div className="school-detail">
                            <a href={route.index}>
                                <img src="/assets/images/mobile-logo.png" />
                            </a>
                        </div>
                        <h5 className="text-center login-title">{t('login:forgotPassword')}:</h5>
                        <br />
                        <form>
                            <div className="form-group">
                                <label>{t('common:email')}</label>
                                <div>
                                    <Input onChange={this._handleChange} name="email" placeholder={t('common:email')} type="text" value={this.state.email} />
                                    {this.state.errors.email && <label className="error text-danger">{this.state.errors.email}</label>}
                                </div>
                            </div>
                            <Button type="button" text={t('login:otp')} login={true} onClick={this._onSave} />
                            <div className="clearfix form-group row">
                                <div className="col-md-12 text-right">
                                    <a className="login-forget" href={route.index}>
                                        {t('login:gotoLogin')}
                                    </a>
                                </div>
                            </div>
                            <span className="powered">
                                {t('login:powered')}{' '}
                                <a href="https://www.classpedia.io" target="_blank">
                                    {t('collabarate')}
                                </a>
                            </span>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const ForgotPassword = withTranslation()(connect(mapStateToProps)(ForgotPasswordComponent))

export { ForgotPassword }
